import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import {
  Box,
  Button,
  Flex,
  FormControl,
  FormLabel,
  Heading,
  IconButton,
  Image,
  Input,
  InputGroup,
  InputRightElement,
  Text,
  useColorMode,
  useColorModeValue,
  useToast,
} from "@chakra-ui/react";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import { loginUser } from "../../API/auth";
import LogoBlack from "../../images/logo.png";
import LogoWhite from "../../images/logo.png";

const TOAST_DEFAULTS = {
  position: "top-right",
  duration: 3000,
  isClosable: true,
};

const SignIn = () => {
  const { colorMode } = useColorMode();
  const toast = useToast();
  const logo = colorMode === "light" ? LogoBlack : LogoWhite;
  const textColor = useColorModeValue("black", "white");
  const bgColor = useColorModeValue("#FAFAF7", "#FAFAF7");

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [btnLoading, setBtnLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);

  const togglePasswordVisibility = () => setShowPassword((prev) => !prev);

  const handleLogin = async (event) => {
    event.preventDefault();
    if (btnLoading) return;

    try {
      setBtnLoading(true);
      console.log(email, password);
      const data = await loginUser({ email, password });
      if (!data?.authToken) {
        throw new Error("No authToken found in response");
      }

      localStorage.setItem("token", data.authToken);
      localStorage.setItem("user", JSON.stringify(data.user));
      localStorage.setItem("role", data.user.role);
      localStorage.setItem("isUserLoggedIn", "true");
      window.location.href = "/dashboard";
    } catch (error) {
      console.error("Login error:", error);
      toast({
        ...TOAST_DEFAULTS,
        title: "Error Signing In",
        description: error.response?.data?.error || "Incorrect Credentials",
        status: "error",
      });
    } finally {
      setBtnLoading(false);
    }
  };

  return (
    <Flex
      direction="column"
      bg={bgColor}
      h="100vh"
      align="center"
      justify="center"
      px={4}
    >
      <Box width={{ base: "100%", md: "400px" }}>
        <form onSubmit={handleLogin}>
          <Image mb={6} src={logo} alt="Logo" mx="auto" />
          <Heading color={textColor} fontSize="32px" mb="10px" textAlign="center">
            Nice to see you!
          </Heading>
          <Text
            color={textColor}
            mb="36px"
            fontWeight="bold"
            fontSize="14px"
            textAlign="center"
          >
            Enter your email and password to sign in
          </Text>

          <FormControl mb="24px" isRequired>
            <FormLabel fontSize="sm" color={textColor}>
              Email
            </FormLabel>
            <Input
              type="email"
              name="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="Enter your email address"
              color={textColor}
              bg={bgColor}
              border="1px solid"
              borderColor={textColor}
              borderRadius="8px"
              fontSize="sm"
              h="46px"
              _placeholder={{ color: "gray.500" }}
              _focus={{
                borderColor: "blue.500",
                boxShadow: "0 0 0 1px blue.500",
              }}
            />
          </FormControl>

          <FormControl mb="24px" isRequired>
            <FormLabel fontSize="sm" color={textColor}>
              Password
            </FormLabel>
            <InputGroup>
              <Input
                name="password"
                type={showPassword ? "text" : "password"}
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="Enter your password"
                color={textColor}
                bg={bgColor}
                border="1px solid"
                borderColor={textColor}
                borderRadius="8px"
                fontSize="sm"
                h="46px"
                _placeholder={{ color: "gray.500" }}
                _focus={{
                  borderColor: "blue.500",
                  boxShadow: "0 0 0 1px blue.500",
                }}
              />
              <InputRightElement width="4.5rem">
                <IconButton
                  size="sm"
                  bg={bgColor}
                  onClick={togglePasswordVisibility}
                  icon={showPassword ? <FaEyeSlash /> : <FaEye />}
                  aria-label={showPassword ? "Hide password" : "Show password"}
                />
              </InputRightElement>
            </InputGroup>
          </FormControl>

          <Button
            type="submit"
            colorScheme="blue"
            variant="solid"
            w="100%"
            h="45px"
            mb="20px"
            mt="20px"
            isLoading={btnLoading}
            isDisabled={btnLoading || !email || !password}
          >
            SIGN IN
          </Button>
          <Button
            as={Link}
            to="/register"
            colorScheme="green"
            variant="solid"
            w="100%"
            h="45px"
            mb="20px"
          >
            SIGN UP
          </Button>
        </form>
      </Box>
    </Flex>
  );
};

export default SignIn;